import React from "react";

export const Header = () => {
  return (
    <div>
      <img
        className="singleBlogPageHeader"
        src={"https://i.ibb.co/fpDKTmw/Single-Blog-Page.jpg"}
        alt=""
      />
    </div>
  );
};
